import Vue from 'vue'
import Vuex from 'vuex'
import Sounds from '@/js/sounds'
import Musics from '@/js/musics'
import app from './modules/app'
import game from './modules/game'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: { app, game, user },
	strict: process.env.NODE_ENV !== 'production'
})



// Watch sounds volume
store.watch(
	() => { return user.state.settings.sounds },
	(newValue) => { Sounds.set_volume(newValue / 10) },
	{ immediate: true }
)

// Watch musics volume
store.watch(
	() => { return user.state.settings.musics },
	(newValue, oldValue) => {
		Musics.set_volume(newValue / 10)

		if (!newValue && oldValue > 0) {
			Musics.stop()
		} else {
			// Musics.play(slug)
		}
		
	},
	{ immediate: true }
)

// Auto save user
store.watch(
	() => { return user.state },
	() => { store.dispatch('save_user') },
	{ deep: true }
)

export default store
